import { createRenderer } from "@stormglass/game-renderer-pixi";
import { useEffect, useRef, useState } from "react";

import { useGameHost, useGameState } from "../game/GameContext";

export function Battlefield(): React.JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);
  const host = useGameHost();
  const { ui } = useGameState();
  const [rendererFailed, setRendererFailed] = useState(false);
  useEffect(() => {
    const renderer = createRenderer();
    const element = containerRef.current;
    if (element === null) return;
    let cancelled = false;
    void renderer
      .mount(element)
      .then(() => {
        if (cancelled) renderer.destroy();
        else host.attachRenderer(renderer);
      })
      .catch((error: unknown) => {
        if (!cancelled) {
          setRendererFailed(true);
          host.reportRendererFailure(error);
        }
      });
    return () => {
      cancelled = true;
      host.detachRenderer(renderer);
      renderer.destroy();
    };
  }, [host]);
  return (
    <div className="battlefield" ref={containerRef}>
      {rendererFailed && (
        <div className="battlefield-fallback" aria-hidden="true">
          <div className="battlefield-fallback__rings">
            <span>ϟ</span>
          </div>
          <i />
          <i />
          <i />
          <i />
          <i />
        </div>
      )}
      <div className="battlefield__vignette" />
      <div className="sr-only" aria-live="polite">
        Round {ui.round}. {ui.quotaRemaining} threats remain. Chamber integrity{" "}
        {ui.integrity} of {ui.maxIntegrity}.
      </div>
    </div>
  );
}
